exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".component-broker-avatar-box[data-v-ac657a2e]{display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:center;align-items:center}.component-broker-avatar[data-v-ac657a2e]{border-radius:50%;position:relative;box-sizing:border-box}.component-broker-avatar-inner[data-v-ac657a2e]{border-radius:50%;overflow:hidden;z-index:3}.component-broker-avatar-star[data-v-ac657a2e]{width:100%;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.component-broker-avatar-star img[data-v-ac657a2e]{margin-right:1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ac657a2e","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/agent/avatar.vue
// module id = 486
// module chunks = 1